// ##### 25-04-30 Komarov
import React, { useEffect, useState } from 'react';
// ##### 24-06-28 Komarov
import { Alert, Input } from 'antd';
// ##### 25-05-21 Komarov
import BookingRQ from './BookingRQ.jsx';
import CanxBookingButton from './CanxBookingButton.jsx';
// ##### 24-04-23 Komarov
import { useSelector } from 'react-redux';
// ##### 25-01-02 Komarov
import { markRequired } from '../../../helpers/markRequired.js';

// ##### 23-09-14 Komarov
// import './CanxBookingCSS.css'

// ##### Komarov 2025-07-14
const CanxBooking = () => {
  // ##### Komarov 2025-07-12
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  const [bookingNumber, setBookingNumber] = useState('');
  const [email, setEmail] = useState('');
  const [clicked, setClicked] = useState(false);
  // ##### Komarov 2025-08-05
  const submit = useSelector(state => state.pagesRedux[state.language]?.Submit || '');
  // ##### 24-06-28 Komarov
  const YourBookingNumber = useSelector(state => state.pagesRedux[state.language]?.YourBookingNumber || '');
  const YourEmailAddress = useSelector(state => state.pagesRedux[state.language]?.YourEmailAddress || '');
  const CancelBooking = useSelector(state => state.pagesRedux[state.language]?.CancelBooking || '');

  const InputBookingNumber = e => {
    setBookingNumber(e.target.value);
  };

  const InputEmail = e => {
    setEmail(e.target.value);
  };

  // ##### 24-03-21 Komarov
  const CanxBooking = (/* e */) => {
    setClicked(true);
    //    e.target.setAttribute('disabled','disabled')
  };

  return (
    // ##### 23-09-14 Komarov
    <div className="CanxForm" data-component="CanxBooking">
      <h2
        style={{ alignSelf: 'center', color: 'darkblue', marginBottom: '4vh' }}
      >
        {/* ##### 24-06-28 Komarov */}
        {CancelBooking}
      </h2>

      <div
        style={{
          display: 'flex',
          flexDirection: 'row',
          justifyContent: 'space-around',
          marginBottom: '1vh',
        }}
      >
        {/* ##### 24-06-28 Komarov */}
        <label>{markRequired(YourBookingNumber)}</label>
        <Input
          style={{ width: '80%', background: 'white' }}
          onChange={InputBookingNumber}
          value={bookingNumber}
        />
        {/* ##### 24-06-28 Komarov: оповещение пользователя о необходимости заполнить это поле */}
        {clicked && bookingNumber === '' && (
          <Alert
            message={'Group_request_destination'}
            type="error"
            showIcon
            closable
            onClose={() => setClicked(false)}
          />
        )}
      </div>
      <div
        style={{
          display: 'flex',
          flexDirection: 'row',
          justifyContent: 'space-around',
        }}
      >
        {/* ##### 24-06-28 Komarov */}
        <label>{markRequired(YourEmailAddress)}</label>
        <Input
          style={{ width: '80%', background: 'white' }}
          onChange={InputEmail}
          value={email}
        />
        {/* ##### 24-06-28 Komarov: оповещение пользователя о необходимости заполнить это поле */}
        {clicked && email === '' && (
          <Alert
            message={'Group_request_destination'}
            type="error"
            showIcon
            closable
            onClose={() => setClicked(false)}
          />
        )}
      </div>

      <button
        type="submit"
        // class={clicked === false? 'SubmitButton':'NonActiveSubmit'}
        // ##### 24-12-19 Komarov
        className="Canx FormBookingButton"
        onClick={CanxBooking}
      >
        {submit}
      </button>
      {clicked === true ? (
        <>
          <CanxBookingButton email={email} bookingNumber={bookingNumber} />
        </>
      ) : null}

      <BookingRQ />
    </div>
  );
};

export default CanxBooking;
